module.exports = __webpack_public_path__ + "images/_/programs/h2whoaHybrid/images/characters/sara_surprised-61e177ce1eeefefed54cdf3a77a4bf34.png";


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoaHybrid/images/characters/sara_surprised.png
// module id = 897
// module chunks = 2